/* Navigation presentation only: search/cart keep their existing controllers. */
(() => {
  if (customElements.get('fate-navigation')) return;
  class FateNavigation extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      this.header = document.querySelector('header-component');
      const cancelClose = () => clearTimeout(this.closeTimer);
      const leave = () => {
        clearTimeout(this.openTimer);
        if (this.mobile.matches || !this.hoverOpened) return;
        this.closeTimer = setTimeout(() => {
          if (!this.dialog.contains(document.activeElement)) this.close();
        }, 220);
      };
      document.querySelectorAll('[data-fate-nav-open]').forEach(trigger => {
        trigger.addEventListener('pointerenter', () => {
          cancelClose();
          if (!this.mobile.matches && this.hover.matches) {
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => this.open(trigger, true), 100);
          }
        }, options);
        trigger.addEventListener('pointerleave', () => clearTimeout(this.openTimer), options);
      });
      this.header?.addEventListener('pointerenter', cancelClose, options);
      this.header?.addEventListener('pointerleave', leave, options);
      this.dialog.addEventListener('pointerenter', cancelClose, options);
      this.dialog.addEventListener('pointerleave', leave, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.dialog.open && !this.mobile.matches) {
          event.preventDefault(); this.close(); this.trigger?.focus({ preventScroll: true });
        }
      }, options);
      window.addEventListener('scroll', () => {
        if (this.dialog.open && !this.mobile.matches) this.close();
      }, { ...options, passive: true });
      document.addEventListener('click', event => {
        const target = event.target.closest('button,[data-fate-nav-open]');
        if (target?.hasAttribute('data-fate-nav-open')) { event.preventDefault(); this.open(target); }
        else if (target?.hasAttribute('data-nav-close')) this.close();
        else if (target?.hasAttribute('data-nav-sub')) this.showPanel(target.dataset.navSub, target);
        else if (target?.hasAttribute('data-nav-back')) this.showPanel(null);
        else if (target?.hasAttribute('data-nav-action')) {
          const selector = target.dataset.navAction === 'cart' ? '[data-testid="cart-drawer-trigger"]' : '#header-component search-button button';
          this.close();
          document.querySelector(selector)?.click();
        } else if (this.dialog.open && !this.mobile.matches && !this.dialog.contains(event.target)) this.close();
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        document.querySelectorAll('[data-fate-nav-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
        this.removeAttribute('data-open');
        this.unlock();
      }, options);
      this.mobile.addEventListener('change', () => { if (this.dialog.open) this.close(); }, options);
      window.addEventListener('resize', () => { if (this.dialog.open) this.position(); }, options);
    }
    unlock() {
      if (this.bodyOverflow !== undefined) document.body.style.overflow = this.bodyOverflow;
      this.bodyOverflow = undefined;
    }
    close() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.removeAttribute('data-open');
      this.hoverOpened = false;
      this.unlock();
      this.dialog.close();
    }
    position() {
      const box = this.header.getBoundingClientRect();
      const top = Math.max(0, this.mobile.matches ? box.top : box.bottom);
      this.style.setProperty('--fate-nav-top', `${Math.round(top)}px`);
      const row = this.header.querySelector('.header__row--top');
      const style = getComputedStyle(row || this.header);
      const paper = style.backgroundColor;
      this.style.setProperty('--fate-nav-paper', paper !== 'rgba(0, 0, 0, 0)' && paper !== 'transparent' ? paper : style.getPropertyValue('--color-background').trim() || getComputedStyle(document.body).backgroundColor);
    }
    open(trigger, fromHover = false) {
      clearTimeout(this.closeTimer);
      if (this.dialog.open) {
        if (!fromHover) { this.hoverOpened = false; this.querySelector('.fate-nav-group a')?.focus({ preventScroll: true }); }
        return;
      }
      this.trigger = trigger;
      this.hoverOpened = fromHover;
      this.showPanel(null, null, false);
      this.position();
      if (this.mobile.matches) {
        this.bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
      } else this.dialog.setAttribute('open', '');
      this.setAttribute('data-open', '');
      document.querySelectorAll('[data-fate-nav-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
      const first = this.mobile.matches ? this.querySelector('[data-nav-close]') : this.querySelector('.fate-nav-group a');
      if (!fromHover) first?.focus({ preventScroll: true });
    }
    showPanel(id, trigger, focus = true) {
      this.querySelector('[data-nav-root]').hidden = Boolean(id);
      this.querySelectorAll('[data-nav-panel]').forEach(panel => { panel.hidden = panel.dataset.navPanel !== id; });
      this.querySelector('.fate-nav-mobile-content').scrollTop = 0;
      if (id) {
        this.backTrigger = trigger;
        if (focus) this.querySelector(`[data-nav-panel="${id}"] h2`)?.focus({ preventScroll: true });
      } else if (focus) this.backTrigger?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      if (this.dialog?.open) this.close();
      if (this.bodyOverflow !== undefined) document.body.style.overflow = this.bodyOverflow;
      this.abort?.abort();
    }
  }
  customElements.define('fate-navigation', FateNavigation);
})();
